import React from 'react';
import FastImage from '../../../common/FastImage';
import {View, Text, TouchableOpacity, Linking} from 'react-native';
import {backArrow, logoName} from '../../../utils/images';
import Header from '../../../commonComponents/Header';
import {Button} from '../../../components/core/Button';
import {useSelector} from 'react-redux';
import {globalFontStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';

const LoginOptions = ({navigation}) => {
  const onFlowSelect = param => {
    navigation.navigate('Login', {isOtpLess: param});
  };
  const globalConfigData = useSelector(
    state => state.utilReducer.globalConfigData,
  );
  const termsAndCondition = globalConfigData?.termsAndCondition;
  const privacyPolicy = globalConfigData?.privacyPolicy;
  const amlPolicy = globalConfigData?.antiMoneyLaundering;

  const onLinkClick = (e, link) => {
    e.preventDefault();
    if (link) {
      Linking.openURL(link);
    }
  };
  return (
    <View style={{flex: 1}}>
      <Header isInternalPage={false} />
      <View
        style={{
          justifyContent: 'center',
          flex: 1,
          paddingHorizontal: 16,
        }}>
        <View style={{alignItems: 'center', marginBottom: 25}}>
          <FastImage
            style={{
              height: 30,
              width: 80,
            }}
            source={logoName()}
          />
          <Text>Trade on your opinion</Text>
        </View>

        {(globalConfigData?.whatsapp_otpless_enabled === undefined ||
          globalConfigData?.whatsapp_otpless_enabled) && (
          <Button
            variant="primary"
            onPress={() => {
              onFlowSelect(true);
            }}
            style={{flex: 0, flexBasis: 'auto', marginBottom: 20}}
          >
            Login via Whatsapp
          </Button>
        )}
        {true && (
          <Button
            variant="primary"
            onPress={() => {
              onFlowSelect(false);
            }}
            style={{flex: 0, flexBasis: 'auto'}}
          >
            Login via Phone No
          </Button>
        )}
      </View>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          marginBottom: 30,
        }}>
        {/*<BouncyCheckbox*/}
        {/*  size={18}*/}
        {/*  disableText={false}*/}
        {/*  fillColor={Colors.tradexBlue}*/}
        {/*  unfillColor="#FFFFFF"*/}
        {/*  iconStyle={{borderColor: 'red'}}*/}
        {/*  innerIconStyle={{borderWidth: 1}}*/}
        {/*  onPress={setSelection}*/}
        {/*/>*/}
        <Text
          style={{
            ...globalFontStyle.appFontSmallText,
            color: Colors.grey,
            flex: 1,
            textAlign: 'center',
          }}>
          By contnuing, you agree to our
          <Text
            style={{
              ...globalFontStyle.appFontSmallText,
              color: '#0d6efd',
            }}
            onPress={e =>
              onLinkClick(
                e,
                privacyPolicy ||
                  'https://tradexapp.zendesk.com/hc/en-us/articles/7198021845149-Privacy-Policy',
              )
            }>
            {' '}
            Privacy Policy,{' '}
          </Text>
          <Text
            className="app-font-small-text"
            style={{
              ...globalFontStyle.appFontSmallText,
              color: '#0d6efd',
            }}
            onPress={e =>
              onLinkClick(
                e,
                termsAndCondition ||
                  'https://tradexapp.zendesk.com/hc/en-us/articles/7197989869213-Terms-Conditions',
              )
            }>
            Terms{' '}
          </Text>
          &{' '}
          <Text
            className="app-font-small-text"
            style={{
              ...globalFontStyle.appFontSmallText,
              color: '#0d6efd',
            }}
            onPress={e =>
              onLinkClick(
                e,
                amlPolicy ||
                  'https://tradexapp.zendesk.com/hc/en-us/articles/11341149311261-Anti-Money-Laundering-Policy',
              )
            }>
            AML Policy.
          </Text>
        </Text>
      </View>
    </View>
  );
};

export default LoginOptions;
